import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const propTypes = {
  toastStyle: PropTypes.object,
  title: PropTypes.string,
  message: PropTypes.string,

  handleClose: PropTypes.func.isRequired,
}

const defaultProps = {
  toastStyle: {
    right: "-38px",
    top: 0
  }
}

// MUI replacement for the old react-bootstrap Toast. Kept absolutely positioned
// (within its relatively-positioned parent) and auto-hiding after 3.5s, matching
// the previous `autohide delay={3500} show={!!message}` behavior so the Gateway
// notification looks/behaves the same.
const AppToast = (props) => {
  const { message, handleClose } = props;

  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(handleClose, 3500);
    return () => clearTimeout(timer);
  }, [message, handleClose]);

  if (!message) return null;

  return (
    <Paper
      elevation={3}
      style={{ position: "absolute", zIndex: 90, ...props.toastStyle }}
      sx={{ width: 350, maxWidth: "100%", overflow: "hidden" }}
    >
      <Box
        sx={{
          px: 1.5,
          py: 1,
          borderBottom: "1px solid rgba(0,0,0,0.05)",
          backgroundColor: "rgba(255,255,255,0.85)",
        }}
      >
        <Typography component="strong" sx={{ fontWeight: 700, fontSize: 14 }}>
          {props.title}
        </Typography>
      </Box>
      <Box sx={{ p: 1.5, fontSize: 14 }}>
        {message}
      </Box>
    </Paper>
  )
};

AppToast.propTypes = propTypes;
AppToast.defaultProps = defaultProps;

export default AppToast;
